import {useState, useEffect, useImperativeHandle, Ref, } from "react"
import { useIntl } from "react-intl"
import {otherTaxesToTotalAmountKeys, TaxType } from "../../interface/orderOfProvision"
import { TaxInput } from "./TaxInput"
import TaxesPaidContext, { useTaxesPaid } from "../../components/context/TaxesPaidContext"
import { useTaxService } from "../../servicesHooks/Tax/useTaxService"

export const OrderItemTaxes = ({
}
) => {
    const { getAllTaxTypes } = useTaxService();
    const { taxesList, setTaxesList } = useTaxesPaid();
    const intl = useIntl()

    useEffect(() => {
        getAllTaxTypes({ offSet: 0, pageSize: 0, params: {forPurchaseInvoices: true, isVatTax: true } }).then((res: any) => {
            const _taxtypes = res.map((item: any) => {
                return {
                    taxType: item.taxtype,
                    taxName: item.taxname,
                    taxValue: item.taxvalue,
                    taxAccount: item.taxaccount,
                    // Si es un impuesto iva, no se puede editar
                    editable: !item.vattax,
                    visible: !item.vattax,
                    taxAccountDesc: item.taxaccountdesc,
                    taxAccountIdentifier: item.taxaccountidentifier,
                    exemptVatTax: item.exemptvattax,
                    vatNotTaxed: item.vatnottaxed
                }
            })            
            setTaxesList(_taxtypes)
        })
    }, [])

    return (      
                <div className="flex flex-column gap-3 my-3">
                    <h4 className="text-base title font-semibold">{intl.formatMessage({ id: 'Taxes' })}</h4>
                    <section className="flex flex-column gap-2 max-w-28rem">
                        {taxesList
                            ?.map((tax: TaxType) => {
                                return (
                                        <TaxInput
                                            tax={tax}
                                        />
                                )
                            })}
                    </section>
                </div>
    );
};
